<template>
  <div :class="tkLoadingClass"
       v-show="show">
    <div class="tk-loading-content"
         :class="{top:tkLoading.top}">
      <div class="tk-loading-content-img"
           :class="{noTitle: !tkLoading.title}">
        <img src="./img/loading.gif"
             alt>
      </div>
      <div class="tk-loading-content-title" v-show="tkLoading.title">{{ tkLoading.title }}</div>
    </div>
    <div class="tk-loading-mask"
         :style="{'background': tkLoading.maskBgColor}"
         v-show="tkLoading.mask"></div>
  </div>
</template>

<script>
/*
author: Jack Zhang
version: 0.0.3
submitDate: 2019-1-17
*/
export default {
  name: "tk-loading",
  data() {
    return {};
  },
  props: {
    tkLoadingClass: {
      type: String,
      default: "tk-loading"
    },
    show: Boolean,
    tkLoading: {
      type: Object,
      default: function() {
        return {
          title: "",
          mask: false,
          top: false,
          fontSize: 0.24,
          maskBgColor: "rgba(0, 0, 0, 0.8)"
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tk-loading {
  .tk-loading-content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1.8rem;
    height: 1.8rem;
    opacity: 0.9;
    background: #3a3a3a;
    border-radius: 0.12rem;
    box-sizing: border-box;
    z-index: 1000;
    .tk-loading-content-img {
      img {
        margin: 0.3rem auto 0.18rem;
        width: 0.72rem;
        height: 0.72rem;
      }

      img.noTitle {
        margin: 0.4rem;
        width: 1rem;
        height: 1rem;
      }
    }

    .tk-loading-content-title {
      font-size: 0.26rem;
      line-height: 0.32rem;
      color: #d2d2d2;
      text-align: center;
      overflow: hidden;
    }
  }
  .top {
    top: 27%;
  }
  .tk-loading-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.7;
    z-index: 999;
    background-color: rgba(0, 0, 0, 1);
  }
}
</style>
